import { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import request from "../../../../Helpers/API";

// Modal de solo consulta con el detalle completo de una condonación del historial —
// CondonacionIntereses/ObtenerCondonacionPorFolio. No permite editar nada.
export const CondonacionInteresDetalleModal = ({ open, onClose, folio }) => {
    const [cargando, setCargando] = useState(false);
    const [detalle, setDetalle] = useState(null);
    const [facturas, setFacturas] = useState([]);

    useEffect(() => {
        if (!open || !folio) return;
        setCargando(true);
        request
            .post(`CondonacionIntereses/ObtenerCondonacionPorFolio?folio=${folio}`, {})
            .then((result) => {
                setDetalle(result?.condonacion || null);
                setFacturas(Array.isArray(result?.facturas) ? result.facturas : []);
                setCargando(false);
            })
            .catch(() => {
                setCargando(false);
                Swal.fire("CONDONACIÓN DE INTERÉS", "No se pudo cargar el detalle de la condonación.", "error");
            });
    }, [open, folio]);

    const handleClose = () => {
        setDetalle(null);
        setFacturas([]);
        onClose();
    };

    const claseEstatus =
        detalle?.estatus === "A" ? "cdi-badge-on" : detalle?.estatus === "R" ? "cdi-badge-rechazada" : "cdi-badge-off";
    const textoEstatus = detalle?.estatus === "A" ? "Autorizada" : detalle?.estatus === "R" ? "Rechazada" : "Autorización pendiente";

    return (
        <Modal open={open} onClose={handleClose}>
            <div className="cdi-modal-overlay">
                <div className="cdi-modal-box cia-detalle-modal-box">
                    <div className="cdi-modal-header">
                        <h3>Detalle de condonación</h3>
                        {detalle && <span className={`cdi-badge ${claseEstatus} cia-detalle-estatus-pill`}>{textoEstatus}</span>}
                        <button type="button" className="cdi-modal-close" onClick={handleClose}>
                            <CloseIcon />
                        </button>
                    </div>

                    <div className="cdi-modal-body">
                        {cargando || !detalle ? (
                            <div className="cdi-tabla-vacio">Cargando...</div>
                        ) : (
                            <>
                                <div className="cia-detalle-resumen">
                                    {detalle.estatus === "A" && (
                                        <div>
                                            <span>Folio</span>
                                            <strong>{detalle.folio}</strong>
                                        </div>
                                    )}
                                    <div>
                                        <span>Autoriza</span>
                                        <strong>{detalle.autoriza || "—"}</strong>
                                    </div>
                                    <div>
                                        <span>Creador</span>
                                        <strong>{detalle.creador || "—"}</strong>
                                    </div>
                                </div>

                                <div className="cia-resumen-encabezados">
                                    <span>Tipo</span>
                                    <span className="cia-celda-num">Saldo</span>
                                    <span className="cia-celda-num">%</span>
                                    <span className="cia-celda-num">Condonado</span>
                                    <span className="cia-celda-num">Interés a pagar</span>
                                </div>
                                <div className="cia-resumen">
                                    <div className="cia-resumen-fila">
                                        <span>Normales</span>
                                        <span className="cia-resumen-monto cia-celda-num">{FormatMoney(detalle.inormal_saldo)}</span>
                                        <span className="cia-celda-num">{detalle.inormal_porcentaje}%</span>
                                        <span className="cia-resumen-condonado cia-celda-num">{FormatMoney(detalle.inormal_descuento)}</span>
                                        <span className="cia-resumen-restante cia-celda-num">{FormatMoney(detalle.inormal_pagado)}</span>
                                    </div>
                                    <div className="cia-resumen-fila">
                                        <span>Moratorios</span>
                                        <span className="cia-resumen-monto cia-celda-num">{FormatMoney(detalle.imoratorio_saldo)}</span>
                                        <span className="cia-celda-num">{detalle.imoratorio_porcentaje}%</span>
                                        <span className="cia-resumen-condonado cia-celda-num">{FormatMoney(detalle.imoratorio_descuento)}</span>
                                        <span className="cia-resumen-restante cia-celda-num">{FormatMoney(detalle.imoratorio_pagado)}</span>
                                    </div>
                                </div>

                                <div className="cia-detalle-comentarios">
                                    <span>Comentarios</span>
                                    <p>{detalle.comentarios || "—"}</p>
                                </div>

                                <div className="cdi-panel-header">
                                    <h3 className="cdi-panel-titulo">Facturas relacionadas</h3>
                                </div>
                                <div className="cdi-tabla-wrap cia-detalle-facturas-tabla">
                                    <table className="cdi-tabla" cellPadding={0} cellSpacing={0}>
                                        <thead>
                                            <tr>
                                                <th><div>Serie</div></th>
                                                <th><div className="borde-izq">No. Factura</div></th>
                                                <th><div className="borde-izq">Saldo</div></th>
                                                <th><div className="borde-izq">Int. Pactado</div></th>
                                                <th><div className="borde-izq">Int. Moratorio</div></th>
                                                <th><div className="borde-izq">Total</div></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {facturas.map((f) => (
                                                <tr key={f.id}>
                                                    <td>{f.serie}</td>
                                                    <td className="cdi-tabla-usuario">{f.documento}</td>
                                                    <td className="cia-celda-num">{FormatMoney(f.saldo)}</td>
                                                    <td className="cia-celda-num">{FormatMoney(f.inormal)}</td>
                                                    <td className="cia-celda-num">{FormatMoney(f.imoratorio)}</td>
                                                    <td className="cia-celda-num">{FormatMoney((f.saldo || 0) + (f.inormal || 0) + (f.imoratorio || 0))}</td>
                                                </tr>
                                            ))}
                                            {facturas.length === 0 && (
                                                <tr>
                                                    <td colSpan={6} className="cdi-tabla-vacio">No hay facturas relacionadas.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default CondonacionInteresDetalleModal;
